import { defineComponent as _defineComponent } from 'vue'
import BCXMessengerUserSelect from '@/components/messenger/User/BCXMessengerUserSelect.vue';
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import BCXUserBanner from '@/components/molecules/BCXUserBanner.vue';
import TagDisplay from '@/components/tagging/TagDisplay.vue';
import { AvailabilityInterface } from '@/models/Availability';
import { Profile, ProfileStoreKey } from '@/models/Profile';
import { User } from '@/models/User';
import AvailabilityService from '@/services/AvailabilityService';
import { getProfile } from '@/services/Profile/Api';
import ProfileSidebarAvailability from '@/views/profile/components/sidebar/ProfileSidebarAvailability.vue';
import {
  computed, provide, ref, watch
} from 'vue';
import { asyncComputed } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarUserSelect',
  props: {
  placeholder: { type: String, default: '' },
  showAvailability: {
    type: Boolean,
    default: true,
  },
  showSkillList: {
    type: Boolean,
    default: true,
  },
  // user: { type: Object as PropType<User | null>, default: null },
  // availability: { type: Object as PropType<AvailabilityInterface | null | false>, default: null },
  // profile: { type: Object as PropType<Profile | null>, default: null },
},
  emits: ['user', 'availability', 'profile'],
  setup(__props, { emit }) {



// dirty hack to get ProfileBasicView working
provide('storeKey', ProfileStoreKey.PROFILE);



const user = ref<User | null>(null);

const userId = computed(() => user.value?.userId ?? '');

const availability = asyncComputed<AvailabilityInterface | null | false>(
  async () => {
    if (!userId.value) return null;

    const availability = await AvailabilityService.getAvailabiltyforUser(userId.value);
    if (!availability) return false;

    return availability;
  },
  null,
  { lazy: true }
);

const profile = asyncComputed<Profile | null>(
  async () => {
    if (!userId.value) return null;
    return getProfile(userId.value);
  },
  null,
  { lazy: true }
);

const onSelectUser = (newUser: User) => {
  user.value = newUser;
};

const isLoading = computed(() => userId.value && !availability.value && !profile.value);

watch(user, (user) => {
  emit('update:user', user);
});

watch(profile, (profile) => {
  emit('update:profile', profile);
});

watch(availability, (availability) => {
  emit('update:availability', availability);
});


return { __sfc: true,emit, user, userId, availability, profile, onSelectUser, isLoading, BCXMessengerUserSelect, BCXMarkdown, BCXUserBanner, TagDisplay, ProfileSidebarAvailability }
}

})